import {Component, OnInit} from '@angular/core';
import {Login} from '../login/login';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../common/user';
import {UserAuthenticationService} from '../common/user-authentication.service';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {PasswordRegexConstant, Utils} from "../common/utils";
import {AllValidationErrors, getFormValidationErrors} from "../common/get-form-validation-errors";
import {AcceptTermsConditions} from "../accept-terms-conditions/accept-terms-conditions";
import {AcceptTermsConditionsService} from "../common/accept-terms-conditions.service";
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {Messages} from "../shared/messages";
import {SystemConfigurationService} from "../common/configuration/system-configuration.service";
import {HttpErrorResponse} from "@angular/common/http";
import {CommonService} from "../common/common.service";

@Component({
    selector: 'dp-connect-reset-password',
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

    user: User;
    resetToken: string;
    validToken: boolean = false;
    formGroup: FormGroup;
    isForgotPassword: boolean;
    routerState : any;
    nextState : any;

    constructor(
        public userAuthenticationService: UserAuthenticationService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public acceptTermsConditionsService: AcceptTermsConditionsService,
        public dialogService : ConfirmDialogService,
        public systemConfigurationService: SystemConfigurationService,
        public commonService: CommonService
        ) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;
    }

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((paramMap: any) => {
            this.resetToken = paramMap.params ? paramMap.params['token'] : undefined;
            if(this.resetToken){
                this.isForgotPassword = true;
                this.validateToken();
            } else {
                this.user = new User(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.user)));
                if (this.routerState){
                    this.nextState = this.routerState.nextState;
                }
            }

        });
        this.formGroup = new FormGroup({'password': Utils.createChangePassFormControl() });
        this.formGroup.addControl( 'retypePassword', new FormControl('',Validators.compose([
            // 1. Password Field is Required
            Validators.required,Utils.passwordMatchValidator(this.formGroup , { mustMatch: true })])));
    }

    validateToken(){
        if (this.resetToken) {
            this.userAuthenticationService.getUserByToken(this.resetToken).subscribe(
                (user) => {
                    this.validToken = true;
                    this.user = new User(user);
                }
            );
        }
    }

    updateUserProfile(): void {
        let errors: AllValidationErrors[] = getFormValidationErrors(this.formGroup.controls);
        if (errors.length == 0 && !!this.user) {
            this.user.registrationToken = this.resetToken;
            this.user.password = this.formGroup.controls['password'].value;
            this.user.retypePassword = this.formGroup.controls['retypePassword'].value;
            if(this.user.passwordChangeRequired && !this.isForgotPassword){
                this.changeUserExpiredPassword();
            } else {
                this.resetPassword();
            }

        }
    }

    changeUserExpiredPassword() {
        this.userAuthenticationService.updateUserPwd(this.user).subscribe(
            (res) => {
                this.user.password = null;
                this.user.retypePassword = null;
                //Load system configuration
                this.systemConfigurationService.loadSystemConfiguration();
                this.navigateToNextStep();

            },
            (errorResponse : HttpErrorResponse) => {
                let connectDialog = new ConnectDialog();
                connectDialog.dialogType = 'ERROR';
                connectDialog.showCancelBtn = false;
                let error = errorResponse.error && errorResponse.error.Error;
                if(error) {
                        //No need to do anything because this will be handled by "getServerMessage" in the ErrorService
                } else {
                    connectDialog.message = Messages.internalError;
                    this.dialogService.confirmDialog(connectDialog).subscribe();
                }
            }
        );
    }

    navigateToNextStep(){
        if(this.user.passwordChangeRequired && !this.isForgotPassword){
            this.checkTermsAndConditionsVersionUptoDate();
        }
    }

    checkTermsAndConditionsVersionUptoDate(){
        const userTermsAcceptedDate = this.user.termsAcceptedDate;
        this.acceptTermsConditionsService.getTermsAndConditions().subscribe(
            (res: AcceptTermsConditions) => {
                if (userTermsAcceptedDate !== res.createdDate) {
                    if (this.nextState) {
                        this.router.navigate(['./accept-terms-conditions/'], {state: {nextState: this.nextState}});
                    } else {
                        this.router.navigate(['./accept-terms-conditions']);
                    }
                } else {
                    if (this.nextState) {
                        this.router.navigate(['./home/matter-summary-home'],{state: {nextState: this.nextState}});
                    } else {
                        this.router.navigate(['./home'] );
                    }
                }

            },
            (error) =>{
                if (this.nextState) {
                    this.router.navigate(['./accept-terms-conditions/'], {state: {nextState: this.nextState}});
                } else {
                    this.router.navigate(['./accept-terms-conditions']);
                }
            }
        );

    }

    resetPassword() : void {
        this.userAuthenticationService.resetPassword(this.user).subscribe(
            (user: User) => {
                if (user) {
                    const login: Login = new Login();
                    login.loginId = user.username;
                    login.password = this.user.password;
                    this.login(login);
                }
            }
        );
    }

    login(login: Login) {
        sessionStorage.clear();
        this.userAuthenticationService.login(login).subscribe(
            (user) => {
                this.userAuthenticationService.setUpUserSession(user);
                this.commonService.invalidateCachedLoggedInUser();
                //Load system configuration
                this.systemConfigurationService.loadSystemConfiguration();
                this.router.navigate(['./connect-list/']);
            }
        );
    }
}
